export default __webpack_public_path__ + "static/media/fill-video-icon.c18c577d.svg";